import React, { PureComponent } from 'react';
import * as echarts from 'echarts';

class DeviceOrderChart extends PureComponent {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      months: this.generateMonths(),
      seriesData: this.generateMockData()
    };
  }

  // 生成近6个月的月份标签（包含当前月）
  generateMonths() {
    const months = [];
    const currentDate = new Date();
    const num = currentDate.getMonth();
    for (let i = num; i >= 0; i--) {
      const monthDate = new Date();
      monthDate.setDate(1); // 固定日期为1号，防止月份进位
      monthDate.setMonth(currentDate.getMonth() - i);
      months.push(`${monthDate.getMonth() + 1}月`);
    }
    console.log(months);
    return months;
  }

  // 获取当前月份和时间段
  getCurrentPeriod() {
    const now = new Date();
    const month = now.getMonth(); // 0-11
    const day = now.getDate();    // 1-31
    const period = Math.min(5, Math.floor((day - 1) / 5)); // 0-5
    return { month, period };
  }

  // 生成模拟数据
  generateMockData() {
    const baseValues = {
      '充电宝': [3010879, 2866553, 3402456, 2547894, 3547856, 2917523, 4012453, 3745219, 3845896, 3489561, 4123741, 3047853],
      '充电线': [524750, 684579, 882541, 1018569, 775614, 1312486, 984512, 1205674, 854612, 975612, 668945, 784512],
      '售货机': [451278, 358974, 367845, 589623, 654128, 897412, 994713, 1045891, 494578, 358989, 774526, 852369],
    };
    const { month, period } = this.getCurrentPeriod();
    if (period === 0) {
      baseValues['充电线'][month] = 55000 + Math.random() * 150000;
      baseValues['售货机'][month] = 50000 + Math.random() * 100000;
      baseValues['充电宝'][month] = 500000 + Math.random() * 100000;
    } else if (period === 1) {
      baseValues['充电线'][month] = 150000 + Math.random() * 200000;
      baseValues['售货机'][month] = 150000 + Math.random() * 150000;
      baseValues['充电宝'][month] = 1000000 + Math.random() * 200000;
    } else if (period === 2) {
      baseValues['充电线'][month] = 200000 + Math.random() * 200000;
      baseValues['售货机'][month] = 150000 + Math.random() * 150000;
      baseValues['充电宝'][month] = 1500000 + Math.random() * 200000;
    } else if (period === 3) {
      baseValues['充电线'][month] = 250000 + Math.random() * 200000;
      baseValues['售货机'][month] = 200000 + Math.random() * 150000;
      baseValues['充电宝'][month] = 2000000 + Math.random() * 200000;
    } else if (period === 4) {
      baseValues['充电线'][month] = 300000 + Math.random() * 200000;
      baseValues['售货机'][month] = 250000 + Math.random() * 150000;
      baseValues['充电宝'][month] = 2500000 + Math.random() * 300000;
    } else {
      baseValues['充电线'][month] = 400000 + Math.random() * 200000;
      baseValues['售货机'][month] = 350000 + Math.random() * 150000;
      baseValues['充电宝'][month] = 3000000 + Math.random() * 300000;
    }

    // 添加随机波动
    return Object.fromEntries(
      Object.entries(baseValues).map(([device, values]) => {
        const newValues = values.map(value =>
          Math.round(value * (0.9 + Math.random() * 0.2)) // 波动±10%
        );
        return [device, newValues];
      })
    );
  }

  // 每3秒更新一次数据
  startDataUpdate() {
    this.updateInterval = setInterval(() => {
      const { seriesData } = this.state;
      const { month } = this.getCurrentPeriod();
      //console.log(month);
      seriesData['充电线'][month] += Math.round(Math.random() * 10);
      seriesData['售货机'][month] += Math.round(Math.random() * 10);
      seriesData['充电宝'][month] += Math.round(Math.random() * 20);
      this.setState({ seriesData: { ...seriesData } }); // 注意：这里需要浅拷贝触发更新
      this.updateChart();
    }, 6000);
  }

  // 更新图表数据
  updateChart() {
    if (this.chart) {
      this.chart.setOption({
        series: [
          { data: this.state.seriesData['充电宝'] },
          { data: this.state.seriesData['充电线'] },
          { data: this.state.seriesData['售货机'] },
        ]
      });
    }
  }

  componentDidMount() {
    this.initChart();
    this.startDataUpdate();
  }

  componentWillUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    if (this.chart) {
      this.chart.dispose(); // 销毁图表释放资源
    }
    window.removeEventListener('resize', this.handleResize);
  }

  // 处理窗口resize
  handleResize = () => {
    if (this.chart) {
      this.chart.resize();
    }
  };

  initChart() {
    const { months, seriesData } = this.state;
    const myChart = echarts.init(this.chartRef.current);
    this.chart = myChart;
    var screenHeight = window.screen.height;
    var gridBottom = '61.8%';
    if(screenHeight < 900) gridBottom = '73%';
    var viewportWidth = window.innerWidth;
    if(viewportWidth > 2300) gridBottom = '51.8%';
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: 'rgba(0,0,0,0.7)',
        textStyle: { color: '#fff' },
        // tooltip中显示原始数值（可选）
        formatter: (params) => {
          let res = params[0].name + '<br/>';
          params.forEach(item => {
            res += `${item.seriesName}: ${item.value.toLocaleString()}<br/>`;
          });
          return res;
        }
      },
      legend: {
        show: true,
        data: ['充电线', '售货机', '充电宝'],
        textStyle: { color: '#fff' },
        bottom: '93.8%',
        right:'5%'
      },
      grid: {
        top:'8%',
        left: '3%',
        right: '4%',
        bottom: gridBottom,//42% 59%
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: { color: '#fff', rotate: 0 }
      },
      yAxis: {
        type: 'value',
        name: '订单量',
        nameTextStyle: {
          padding: [0, 50, 0, 0]
        },
        axisLabel: {
          color: '#5a8bfa',
          // 核心：将数值转换为k单位（如1000→1k，2500→2.5k）
          formatter: (value) => {
            if (value >= 1000) {
              return (value / 1000) + 'k';
            }
            return value; // 小于1000的数值直接显示
          }
        },
        splitLine: { lineStyle: { color: 'rgba(90,139,250,0.1)' } }
      },
      series: [
        {
          name: '充电宝',
          type: 'bar',
          stack: '总量',
          data: seriesData['充电宝'],
          itemStyle: { color: '#FF6384' }
        },
        {
          name: '充电线',
          type: 'bar',
          stack: '总量',
          data: seriesData['充电线'],
          itemStyle: { color: '#36A2EB' }
        },
        {
          name: '售货机',
          type: 'bar',
          stack: '总量',
          data: seriesData['售货机'],
          itemStyle: { color: '#FFCE56' }
        },
      ]
    };

    myChart.setOption(option);
    window.addEventListener('resize', this.handleResize);
  }

  render() {
    return (
      <div
        ref={this.chartRef}
        style={{ width: '100%', height: '450px' }}
      />
    );
  }
}

export default DeviceOrderChart;
